module.exports = "<mat-list-item>\r\n  <mat-icon mat-list-avatar>photo_library</mat-icon>\r\n  <h4 mat-line>{{catalog.title}}</h4>\r\n</mat-list-item>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/catalog/catalog-item/catalog-item.component.html
// module id = 987
// module chunks = 0